import React, { useEffect, useState } from 'react';

const UseScreen = () => {
    return window.innerWidth;
}

export { UseScreen }